<div mat-dialog-header>
    <h1 mat-dialog-title fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <mat-icon *ngIf="ShowIcon" [style.color]="IconColor">{{IconName}}</mat-icon>
        <span>{{TitleText}}</span>
    </h1>
</div>
<div mat-dialog-content>
    <div [innerHTML]="MessageText | safeHTML"></div>
    <div layout="row" layout-align="start center" fxLayoutGap="20px">
        <mat-form-field appearance="standard" style="margin-bottom:0">
            <input matInput 
                [(ngModel)]="FirstName" 
                name="parentFirstName" 
                placeholder="First Name" 
                aria-label="Parent/Guardian First Name"
                required
            >
        </mat-form-field>
        <mat-form-field appearance="standard" style="margin-bottom:0">
            <input matInput 
                [(ngModel)]="LastName" 
                name="parentLastName" 
                placeholder="Last Name" 
                aria-label="Parent/Guardian Last Name"
                required
            >
        </mat-form-field>
        <mat-form-field appearance="standard" style="margin-bottom:0">
            <input matInput 
                [(ngModel)]="Email" 
                name="parentEmail" 
                placeholder="Email" 
                #email="ngModel"
                aria-label="Parent/Guardian Email"
                email
                required
            >
        </mat-form-field>
        <mat-form-field appearance="standard" style="margin-bottom:0">
            <input matInput 
                [(ngModel)]="Phone" 
                name="parentPhone" 
                placeholder="Phone" 
                aria-label="Parent/Guardian Phone"
                required
            >
        </mat-form-field>
    </div>
    <div>
        <mat-error *ngIf="email.errors?.['required']">Missing parent/guardian email.</mat-error>
        <!-- <mat-error *ngIf="email.errors?.['email'] || !IsValidEmail(email.value)">Invalid email address.</mat-error> -->
        <mat-error *ngIf="email.errors?.['email']">Invalid email address.</mat-error>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()">{{OKText}}</button>
</div>